const configuredProjectId = import.meta.env.VITE_SUPABASE_PROJECT_ID ?? "";
const configuredSupabaseUrl = (import.meta.env.VITE_SUPABASE_URL ?? "").replace(/\/+$/, "");
const projectIdFromUrl = configuredSupabaseUrl.match(/^https:\/\/([a-z0-9-]+)\.supabase\.co/i)?.[1] ?? "";

export const projectId = configuredProjectId || projectIdFromUrl;
export const publicAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? "";

export const supabaseUrl = configuredSupabaseUrl || (projectId ? `https://${projectId}.supabase.co` : "");
export const functionsBaseUrl = `${supabaseUrl}/functions/v1`;
export const aqlVisionApiUrl = functionsBaseUrl;

export const hasSupabaseAnonKey = Boolean(publicAnonKey);
export const hasSupabaseConfig = Boolean(supabaseUrl && publicAnonKey);
